<template>
  <v-dialog v-model="show" scrollable max-width="1200px" persistent>
    <v-card>
      <v-card-title class="grey lighten-3">
        <v-row>
          <v-icon class="draggable">mdi-drag</v-icon>
          <v-col class="py-0">Add Rates Season</v-col>
        </v-row>
      </v-card-title>
      <v-container fluid>
        <v-card class="pa-3">
          <v-row dense>
            <v-col cols="12" sm="3">
              <dates-range-picker
                :gtDateFromString="dateFrom"
                :gtDateToString="dateTo"
                @onRangeSelected="onDateRangeSelected"
                :outlined="outlinedInputs"
              ></dates-range-picker>
            </v-col>
            <v-col sm="3">
              <rate-type-select
                :rateTypeCode="rateTypeCode"
                @onSelect="onRateTypeSelect"
                :outlined="outlinedInputs"
                hideNotInUse
              ></rate-type-select>
            </v-col>
            <v-col>
              <agent-group-select
                :groups-only="true"
                v-model="groupId"
                :outlined="outlinedInputs"
              ></agent-group-select>
            </v-col>
            <v-col
              v-if="
                $store.getters.hasAccessTo(
                  'administration_panel:business_models'
                )
              "
            >
              <business-model-list-select
                v-model="businessModel"
                :outlined="outlinedInputs"
              ></business-model-list-select>
            </v-col>
            <v-col
              v-if="
                $store.getters.hasAccessTo(
                  'administration_panel:business_models'
                )
              "
            >
              <v-text-field
                v-model="supplierCommission"
                label="Supplier Commission"
                :outlined="outlinedInputs"
                :disabled="!bmUseCommission"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <currency-list-select
                customLabel="Currency"
                v-model="currencyCode"
                :outlined="outlinedInputs"
              ></currency-list-select>
            </v-col>
            <v-col>
              <v-text-field
                v-model="ratePlan"
                label="Rate Plan"
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-col>

            <v-col>
              <v-text-field
                v-model="markup"
                label="Markup (%)"
                type="number"
                min="0"
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="minStay"
                label="Min Stay"
                type="number"
                min="0"
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="maxStay"
                label="Max Stay"
                type="number"
                min="0"
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="minPax"
                label="Min Pax"
                type="number"
                min="0"
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="maxPax"
                label="Max Pax"
                type="number"
                min="0"
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="remarks"
                label="Remarks"
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-switch v-model="exception" label="Exception"></v-switch>
            </v-col>
            <v-col>
              <v-switch
                v-model="api"
                label="API"
                @change="onApiChange"
              ></v-switch>
            </v-col>
            <v-col v-if="$store.getters.hasAccessTo('third_party:marketplace')">
              <v-switch
                v-model="marketplace"
                label="Marketplace"
                @change="onMarketplaceChange"
              ></v-switch>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
      <v-card-text class="pa-3">
        <v-card outlined>
          <v-data-table
            :items="serviceRates"
            item-key="serviceId"
            :headers="visibleHeaders"
            v-model="selectedServiceRates"
            show-select
            ref="dataTable"
          >
            <template v-slot:item.marketPlace="{ item }">
              <v-simple-checkbox
                v-model="item.marketPlace"
                hide-details
                color="primary"
              />
            </template>
            <template v-slot:item.api="{ item }">
              <v-simple-checkbox
                v-model="item.api"
                hide-details
                color="primary"
              />
            </template>
            <template v-slot:item.adultBuy1="{ item }">
              <v-text-field
                type="number"
                v-model="item.adultBuy1"
                min="0"
                class="pt-1 ma-0 short-input"
                @change="onPriceChange('adultBuy')(item)"
                @keyup.enter="onKeyUpEnter('adultBuy')(item)"
                :ref="`adultBuy_${item.serviceId}`"
                @paste="onPaste($event, 'adultBuy', item)"
              ></v-text-field>
            </template>
            <template v-slot:item.adultSell1="{ item }">
              <v-text-field
                type="number"
                v-model="item.adultSell1"
                min="0"
                class="pt-1 ma-0 short-input"
                @change="onPriceChange('adultSell')(item)"
                @keyup.enter="onKeyUpEnter('adultSell')(item)"
                :ref="`adultSell_${item.serviceId}`"
                @paste="onPaste($event, 'adultSell', item)"
              ></v-text-field>
            </template>
            <template v-slot:item.childBuy1="{ item }">
              <v-text-field
                type="number"
                v-model="item.childBuy1"
                min="0"
                class="pt-1 ma-0 short-input"
                @change="onPriceChange('childBuy')(item)"
                @keyup.enter="onKeyUpEnter('childBuy')(item)"
                :ref="`childBuy_${item.serviceId}`"
                :disabled="!perPersonRates"
                @paste="onPaste($event, 'childBuy', item)"
              ></v-text-field>
            </template>
            <template v-slot:item.childSell1="{ item }">
              <v-text-field
                type="number"
                v-model="item.childSell1"
                min="0"
                class="pt-1 ma-0 short-input"
                @change="onPriceChange('childSell')(item)"
                @keyup.enter="onKeyUpEnter('childSell')(item)"
                :ref="`childSell_${item.serviceId}`"
                :disabled="!perPersonRates"
                @paste="onPaste($event, 'childSell', item)"
              ></v-text-field>
            </template>
            <template v-slot:item.infantBuy1="{ item }">
              <v-text-field
                type="number"
                v-model="item.infantBuy1"
                min="0"
                class="pt-1 ma-0 short-input"
                @change="onPriceChange('infantBuy')(item)"
                @keyup.enter="onKeyUpEnter('infantBuy')(item)"
                :ref="`infantBuy_${item.serviceId}`"
                :disabled="!perPersonRates"
                @paste="onPaste($event, 'infantBuy', item)"
              ></v-text-field>
            </template>
            <template v-slot:item.infantSell1="{ item }">
              <v-text-field
                type="number"
                v-model="item.infantSell1"
                min="0"
                class="pt-1 ma-0 short-input"
                @change="onPriceChange('infantSell')(item)"
                @keyup.enter="onKeyUpEnter('infantSell')(item)"
                :ref="`infantSell_${item.serviceId}`"
                :disabled="!perPersonRates"
                @paste="onPaste($event, 'infantSell', item)"
              ></v-text-field>
            </template>
          </v-data-table>

          <v-row v-if="debug">
            <v-col>
              <code>{{ bmUseCommission }}</code>
            </v-col>
          </v-row>
        </v-card>
      </v-card-text>

      <v-card-actions class="grey lighten-4">
        <v-spacer></v-spacer>
        <v-btn @click="$emit('close')" color="warning" text>Cancel</v-btn>
        <v-btn
          color="secondary"
          text
          :disabled="!isValid"
          @click="saveAndNewSeason"
          >Save &amp; New Season</v-btn
        >

        <v-btn color="secondary" text :disabled="!isValid" @click="saveAndClear"
          >Save &amp; Clear</v-btn
        >
        <v-btn color="primary" :disabled="!isValid" @click="onSaveAndClose"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  priceProperties,
  priceMapper,
} from "../edit/price-details/price-properties";
import DatesRangePicker from "../../../shared/DatesRangePicker";
import { piHeaders, ppHeaders } from "./add-rates-season-headers";
import RateTypeSelect from "../../../shared/RateTypeListSelect";
import AgentGroupSelect from "../../../shared/AgentGroupSelect";
import CurrencyListSelect from "../../../shared/CurrencyListSelect";

import { SUPPLIER_PRICES_CREATE_MUTATION } from "../../../../../constants/graphql";
import EventBus from "../../../../../store/event-bus";
import moment from "moment";
import BusinessModelListSelect from "../../../shared/BusinessModelListSelect";
import gql from "graphql-tag";
const BUSINESS_MODEL_INFO = gql`
  query businesModelInfo($filter: BusinessModelFilterType) {
    businessModelInfo: businessModels(filter: $filter) {
      edges {
        node {
          id
          name
          code
          commission
        }
      }
    }
  }
`;
export default {
  name: "add-rates-season",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    services: {
      type: Array,
      default: () => {},
    },
    supplier: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    DatesRangePicker,
    RateTypeSelect,
    AgentGroupSelect,
    CurrencyListSelect,
    BusinessModelListSelect,
  },

  data() {
    return {
      debug: false,
      dateFrom: moment().toISOString(true),
      dateTo: moment().add(1, "day").toISOString(true),
      rateTypeCode:
        this.supplier && this.supplier.defaultRateTypeCode
          ? this.supplier.defaultRateTypeCode
          : "",
      groupId: "",

      currencyCode:
        this.supplier && this.supplier.currencyCode
          ? this.supplier.currencyCode
          : "",
      ratePlan: "",
      markup: 0,
      minStay: 0,
      maxStay: 0,
      minPax: 0,
      maxPax: 0,
      exception: false,
      businessModel: "BM1",
      supplierCommission: 0,
      serviceRates: [],
      selectedServiceRates: [],
      selectedServices: [],
      headers: [...ppHeaders],
      afterSaveAction: () => {},
      selectedRateType: null,
      marketplace: false,
      api: true,
      remarks: "",
    };
  },

  methods: {
    onApiChange() {
      this.serviceRates = this.serviceRates.map((sr) => ({
        ...sr,
        api: this.api,
      }));
      //refresh selected rates
      this.selectedServiceRates = this.selectedServiceRates.map((sr) => ({
        ...sr,
        api: this.api,
      }));
    },
    onMarketplaceChange() {
      this.serviceRates = this.serviceRates.map((sr) => ({
        ...sr,
        marketPlace: this.marketplace,
      }));
      //refresh selected rates
      this.selectedServiceRates = this.selectedServiceRates.map((sr) => ({
        ...sr,
        marketPlace: this.marketplace,
      }));
    },
    saveAndNewSeason() {
      this.afterSaveAction = () => {
        //this.updateServiceRates();
        //this.selectedServiceRates = []; keep selected
        this.dateFrom = moment(this.dateTo).add(1, "day").toISOString(true);
        this.dateTo = "";
      };
      this.saveRates();
    },
    saveAndClear() {
      this.afterSaveAction = () => {
        this.dateFrom = "";
        this.dateTo = "";
        this.updateServiceRates();
        this.selectedServiceRates = [];
        this.businessModel = "BM1";
        this.supplierCommission = 0;
      };
      this.saveRates();
    },
    onSaveAndClose() {
      this.afterSaveAction = () => {
        this.$emit("close");
      };
      this.saveRates();
    },
    saveRates() {
      this.$apollo
        .mutate({
          mutation: SUPPLIER_PRICES_CREATE_MUTATION,
          variables: {
            prices: this.validRates,
          },
        })
        .then((data) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Rates Saved",
          });
          EventBus.$emit("refetch-supplier-rates");
          this.afterSaveAction();
        })
        .catch((error) => console.error(error));
    },
    updateServiceRates() {
      //console.log("updateServiceRates");
      this.serviceRates = this.services
        .filter((s) => !s.node.notInUse)
        .map((s) => ({
          ...priceProperties,
          serviceId: s.node.id,
          service:
            s.node.code != ""
              ? `${s.node.name.toString()} (${s.node.code.toString()})`
              : s.node.name.toString(),
        }));
    },
    onPriceChange(field) {
      return (item) => {
        const markup = Number(this.markup) / 100;

        for (let i = 1; i <= 7; i++) {
          item[`${field}${i}`] = Number(item[`${field}1`]);
          if (field.indexOf("Buy") != -1) {
            item[`${field.replace("Buy", "Sell")}${i}`] =
              Number(item[`${field}1`]) + Number(item[`${field}1`]) * markup;
            item.markup = markup * 100;
          }
        }

        //update selected rates
        this.selectedServiceRates = [
          item,
          ...this.selectedServiceRates.filter(
            (selected) => selected.serviceId != item.serviceId
          ),
        ];
      };
    },
    onDateRangeSelected(payload) {
      this.dateFrom = payload.dateFrom;
      this.dateTo = payload.dateTo;
      console.log("onDateRangeSelected", payload);
      if (payload.source == "from") {
        this.dateTo = moment(this.dateFrom).add(1, "day").toISOString(true);
      }
    },
    onRateTypeSelect(payload) {
      this.rateTypeCode = payload.code;
      this.ratePlan = payload.code;
      this.selectedRateType = { ...payload };
      this.minPax = Number(payload.minPax);
      this.maxPax = Number(payload.maxPax);
      this.minStay = Number(payload.minStay);
      this.maxStay = Number(payload.maxStay);
    },
    onKeyUpEnter(field) {
      return (item) => {
        const dataTable = this.$refs.dataTable;
        const nextIndex = dataTable.internalCurrentItems.indexOf(item) + 1;
        if (nextIndex < dataTable.internalCurrentItems.length) {
          const nextRow = dataTable.internalCurrentItems[nextIndex];
          this.$refs[`${field}_${nextRow.serviceId}`].$el
            .querySelector("input")
            .focus();
          this.$refs[`${field}_${nextRow.serviceId}`].$el
            .querySelector("input")
            .select();
        }
      };
    },
    onPaste($event, field, item) {
      const paste = $event.clipboardData.getData("text/plain");

      const pasteRows = paste.split("\n");

      if (pasteRows.length > 1) {
        const fields = [
          "adultBuy",
          "adultSell",
          "childBuy",
          "childSell",
          "infantBuy",
          "infantSell",
        ];
        $event.preventDefault();
        //parsing pasted data
        const parsed = pasteRows.map((row) => {
          let fieldIndex = fields.indexOf(field);
          const parsedRow = {};
          const cols = row.split("\t");

          for (const col of cols) {
            const f = fields[fieldIndex];
            if (f && !isNaN(Number(col))) {
              parsedRow[f] = Number(col);
            }
            fieldIndex++;
          }
          return parsedRow;
        });
        //applying pasted data
        let rowIndex = this.serviceRates.indexOf(item);
        if (rowIndex > -1) {
          for (const newRate of parsed) {
            for (const newRateField of Object.keys(newRate)) {
              if (this.serviceRates[rowIndex]) {
                for (let i = 1; i <= 7; i++) {
                  this.serviceRates[rowIndex][`${newRateField}${i}`] =
                    newRate[newRateField];
                }
                //update selected rates
                this.selectedServiceRates = [
                  this.serviceRates[rowIndex],
                  ...this.selectedServiceRates.filter(
                    (selected) => selected != item
                  ),
                ];
              }
            }
            rowIndex++;
          }
        }
      }
    },
  },

  computed: {
    bmUseCommission() {
      return (
        this.businessModelInfo &&
        this.businessModelInfo.edges &&
        this.businessModelInfo.edges.length > 0 &&
        this.businessModelInfo.edges[0].node.commission
      );
    },
    visibleHeaders() {
      const headers = (
        this.perPersonRates ? [...ppHeaders] : [...piHeaders]
      ).filter((h) => {
        if (h.name == "marketPlace") {
          return this.$store.getters.hasAccessTo("third_party:marketplace");
        } else {
          return true;
        }
      });
      return this.supplier && this.supplier.extrasChildPrice
        ? headers.filter(
            (h) => !h.name.includes("child") && !h.name.includes("infant")
          )
        : headers;
    },
    perPersonRates() {
      return this.selectedRateType && this.selectedRateType.includePax;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return (
        this.selectedServiceRates &&
        this.selectedServiceRates.length > 0 && //https://tracker.globetrack.ie/issues/6444
        this.dateFrom != "" &&
        this.dateTo != "" &&
        this.currencyCode != "" &&
        this.rateTypeCode != ""
      );
    },
    validRates() {
      if (this.isValid) {
        return this.selectedServiceRates
          .map((sr) => ({
            ...sr,
            groupId: this.groupId,
            rateTypeCode: this.rateTypeCode,
            ratePlan: this.ratePlan,
            exception: this.exception,
            minStay: Number(this.minStay),
            maxStay: Number(this.maxStay),
            minPax: Number(this.minPax),
            maxPax: Number(this.maxPax),
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,

            currencyCode: this.currencyCode,
            businessModel: this.businessModel,
            supplierCommission: this.supplierCommission,
            remarks: this.remarks,
          }))
          .map(priceMapper);
      } else {
        return [];
      }
    },
  },
  watch: {
    show(s) {
      if (s) {
        this.updateServiceRates();
        this.selectedServiceRates = [];
      }
    },
    supplier(newSupplier) {
      this.rateTypeCode = newSupplier.defaultRateTypeCode
        ? newSupplier.defaultRateTypeCode
        : "";
      this.currencyCode = newSupplier.currencyCode
        ? newSupplier.currencyCode
        : "";
    },
  },
  apollo: {
    businessModelInfo: {
      query: BUSINESS_MODEL_INFO,
      variables() {
        return {
          filter: {
            code_eq: this.businessModel,
          },
        };
      },
      skip() {
        return !this.businessModel || this.businessModel == "";
      },
    },
  },
};
</script>

<style scoped>
.short-input {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/supplier-rates/add/AddRatesSeason.vue